<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
            
      <h1 class="title center__text">ENVOI CAMPAGNE SMS  POUR LES CHR (CAFÉS, HÔTELS, RESTAURANTS)</h1>
          <img class="card__image" src="/../images/cafe.png" alt="" />
      <p>
        De plus en plus d'entreprises du secteur des cafés, hôtels et restaurants 
        se tournent vers le SMS, et cela n'est pas sans raison !
      </p>
      <p>
        L'objectif est de communiquer de manière rapide et efficace avec vos
        clients afin d'établir une relation de proximité, de confiance et d'attirer de nouveaux clients.
      </p>
      <p>
        De plus, grâce aux statistiques, vous pourrez facilement mesurer la délivrabilité de vos SMS
         (envoyés, reçus, lus) et suivre le retour sur investissement (ROI) en fonction de la fréquentation 
         et du nombre de réservations dans votre établissement.
      </p>
      <p>
        Pour les CHR (Cafés, Hôtels, Restaurants), l'utilisation du SMS peut être régulière au quotidien,
        ainsi que pour des événements ponctuels.
      </p>
      <h2>Dans le cadre de votre activité quotidienne</h2>
      <p>
        Chaque matin, vous avez la possibilité d'envoyer les plats du jour, et une fois par semaine, 
        vous pouvez communiquer vos offres promotionnelles. Ces actions récurrentes renforceront l'attachement 
        de vos clients envers votre restaurant et ne vous prendront que quelques minutes.
      </p>
      <p>
        De plus, il est très apprécié par les consommateurs de recevoir une confirmation de leur réservation. 
        Cela leur permet d'être rassurés quant à la prise en compte de leur réservation et leur donne accès à 
        tous les détails en un instant seulement (par exemple, en ajoutant un lien de localisation dans votre SMS).
      </p>
      <p>
        Le SMS est également un allié précieux en cas d'imprévus entraînant la fermeture de votre établissement 
        (conditions météorologiques, grèves, etc.).
      </p>
      <h2>Lors d'événements spéciaux</h2>
      <p>
        Si vous prévoyez une soirée spéciale dans votre établissement, telle qu'un concert ou un cocktail,
        vous pouvez envoyer un SMS marketing à vos clients pour leur indiquer la date et l'heure de l'événement.
      </p>
      <p>
        Ainsi, vous éviterez les événements manqués et les clients déçus de ne pas avoir été informés,
        malgré vos autres supports de communication tels que les flyers !
      </p>
      <p>
        Le SMS peut également être utilisé de manière opportune pour informer vos clients du lancement 
        d'une nouvelle carte ou lors d'occasions spéciales telles que la Saint-Valentin, la Fête des Mères, Noël, etc.
      </p>
      <h2>Exemples de campagnes SMS :</h2>
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/cafe-resto-1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/cafe-resto-2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/cafe-resto-3.png" />
        </div>
      </div>
     
    
     
    </section>
    <SideNav/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
